import { render } from "./SpacingDrop.vue?vue&type=template&id=681d8bda"
import script from "./SpacingDrop.vue?vue&type=script&lang=js"
export * from "./SpacingDrop.vue?vue&type=script&lang=js"

import "./SpacingDrop.vue?vue&type=style&index=0&id=681d8bda&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__